
/**
 * Icon optimizer - Preloads commonly used icons to prevent layout shifts
 * By preloading icon paths, we avoid flashes of unstyled content
 */

// List of common icons used across the app
const commonIcons = [
  'check',
  'x',
  'chevron-right',
  'chevron-left',
  'arrow-right',
  'user',
  'mail',
  'lock',
  'alert-circle',
  'info'
];

/**
 * Preloads commonly used Lucide icons to prevent layout shifts
 * This improves CLS (Cumulative Layout Shift) metric
 */
export const preloadCommonIcons = () => {
  try {
    // Create SVG namespace once 
    const svgNS = 'http://www.w3.org/2000/svg';
    const preloadContainer = document.createElement('div');
    preloadContainer.style.position = 'absolute';
    preloadContainer.style.width = '0';
    preloadContainer.style.height = '0';
    preloadContainer.style.overflow = 'hidden';
    preloadContainer.style.visibility = 'hidden';
    
    // Icon definitions for common Lucide icons
    // Each entry is [iconName, svgPath]
    const iconDefinitions: [string, string][] = [
      ['check', 'M5 12l5 5 9-9'],
      ['x', 'M18 6L6 18M6 6l12 12'],
      ['chevron-right', 'M9 18l6-6-6-6'],
      ['chevron-left', 'M15 18l-6-6 6-6'],
      ['arrow-right', 'M5 12h14M12 5l7 7-7 7'],
      ['user', 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2 M12 3a4 4 0 100 8 4 4 0 000-8z']
    ];
    
    // Preload each icon
    iconDefinitions.forEach(([name, path]) => {
      const svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', '24');
      svg.setAttribute('height', '24');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('data-preloaded-icon', name);
      
      const pathEl = document.createElementNS(svgNS, 'path');
      pathEl.setAttribute('d', path);
      svg.appendChild(pathEl);
      
      preloadContainer.appendChild(svg);
    });
    
    // Append to body if it exists, otherwise wait for it
    if (document.body) {
      document.body.appendChild(preloadContainer);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.body.appendChild(preloadContainer);
      });
    }
  } catch (e) {
    // Silently fail - preloading icons is not critical
    console.warn('Icon preloading failed:', e);
  }
};

export default preloadCommonIcons;
